import React, { useEffect, useReducer, useState } from 'react';
import { P, H4 } from '../../components/Typography/styles';
import { 
  GlobalDebtContainer,
  GlobalDebtWrapper,
  GlobalDebtHeader,
  GlobalDebtHeaderTitle,
  GlobalDebtHeaderArea,
  GlobalDebtContent,
} from './styles';
import { globalDebtSteps } from '../../helpers/enum';
import { GlobalDebtContext } from '../../store';
import globalDebtReducer from '../../store/GlobalDebt';
import INITIAL_STATE_GLOBAL_DEBT from '../../store/GlobalDebt/state';
import colors from '../../assets/styles/colors';
import BasicRequestInformationPage from './BasicRequestInformation';
import FinanceInformationOnePage from './FinanceInformationOne';
import FinanceInformationTwoPage from './FinanceInformationTwo';
import CentralInformationPage from './CentralInformation';
import OtherCertifiedIncomePage from './OtherCertifiedIncome';
import FormSteps from '../../components/FormSteps';
import Copyright from '../../components/Copyright';
import { useHistory, useLocation } from 'react-router-dom';
import { default as GlobalDebtTypes } from '../../store/GlobalDebt/types';
import { getCreditById } from '../../services/credit';
import { getSolicitationById } from '../../services/solicitations';
import Loader from '../../components/Loader';
import { getLastCreditByClient } from '../../services/credit';
import { getSimulacionById } from '../../services/simulation';

const GlobalDebtPage = () => {
  const location = useLocation();
  const history = useHistory();
  const [globalDebt, setGlobalDebt] = useReducer(globalDebtReducer, INITIAL_STATE_GLOBAL_DEBT);
  const [activeStep, setActiveStep] = useState(globalDebtSteps.BASIC_REQUESTING_INFORMATION);
  const [lastStep, setLastStep] = useState(globalDebtSteps.DEFAULT);
  const [isLoading, setIsLoading] = useState(true);

  const [simulation, setSimulation] = useReducer(globalDebtReducer, INITIAL_STATE_GLOBAL_DEBT);

  async function initializedStateComponent() {
    try {
      const creditResponse = await getCreditById(location.idCredit);
      const solicitationResponse = await getSolicitationById(location.idCredit);
      const lastCreditResponse = await getLastCreditByClient(location.client.id);

      setGlobalDebt({
        type: GlobalDebtTypes.SET_CREDIT,
        credit: creditResponse.data
      })

      setGlobalDebt({
        type: GlobalDebtTypes.SET_SOLICITATION,
        solicitation: solicitationResponse.data
      })

      setGlobalDebt({
        type: GlobalDebtTypes.SET_LAST_CREDIT,
        lastCredit: lastCreditResponse.data
      })

      if(solicitationResponse.data) {
        const simulationResponse = await getSimulacionById(solicitationResponse.data.simulacion.idSimulacion);
        setGlobalDebt({
          type: GlobalDebtTypes.SET_SIMULATION,
          simulation: simulationResponse.data
        })
      }

      setIsLoading(false);
    } catch (error) {
      console.log(error.response)
    }
  }

  useEffect(() => {
    if(!location.idCredit) {
      return history.push('/admin/dashboard')
    }

    initializedStateComponent();
  }, [])

  return (
    <GlobalDebtContainer id="global-debt-page">
      <GlobalDebtWrapper>
        <GlobalDebtHeader>
          <GlobalDebtHeaderTitle>Clientes</GlobalDebtHeaderTitle>
          <GlobalDebtHeaderArea>
            <H4 color={colors.textPrimary}>Capacidad de pago</H4>
            <P bold color={colors.textPrimary}>
            {globalDebt.solicitation?.cliente.nombres} {globalDebt.solicitation?.cliente.tipoIdentificacion.toUpperCase()}. {globalDebt.solicitation?.cliente.identificacion}
            </P>
          </GlobalDebtHeaderArea>
        </GlobalDebtHeader>

        {isLoading ? <Loader /> : (
          <GlobalDebtContent id="global-debt-steps">
            <FormSteps lastStep={lastStep} steps={[
              {number: globalDebtSteps.BASIC_REQUESTING_INFORMATION, label: 'Inf. basica solicitante'},
              {number: globalDebtSteps.FINANCE_DATA_ONE, label: 'Inf. financiera y central'}
            ]} />

            <GlobalDebtContext.Provider value={{ globalDebt, setGlobalDebt }}>
              {activeStep === globalDebtSteps.BASIC_REQUESTING_INFORMATION && (
                <BasicRequestInformationPage setActiveStep={setActiveStep} setLastStep={setLastStep} />
              )}

              {activeStep === globalDebtSteps.FINANCE_DATA_ONE && (
                <FinanceInformationOnePage setActiveStep={setActiveStep} setLastStep={setLastStep} />
              )}

              {activeStep === globalDebtSteps.CENTRAL_INFORMATION && (
                <CentralInformationPage setActiveStep={setActiveStep} setLastStep={setLastStep} />
              )}

              {activeStep === globalDebtSteps.OTHER_CERTIFIED_INCOME && (
                <OtherCertifiedIncomePage setActiveStep={setActiveStep} setLastStep={setLastStep} />
              )}
            </GlobalDebtContext.Provider>
          </GlobalDebtContent>
        )}
      </GlobalDebtWrapper>
      <Copyright />
    </GlobalDebtContainer>
  )
}

export default GlobalDebtPage;
